import React from 'react';
import "./style.less";
import Colors from "~/assets/colors.jpg";

const COLORS = [
	"#6D506F",
	"#607975",
	"#BAA9B1",
	"#D7D3D0",
];

export default function ColorsPage() {
	return <div className="colorsPage">
		<h2 className="colorsPage__title">Barvy svatby</h2>
		<p className="colorsPage__weddingColors">
			{COLORS.map(color => <span className="colorsPage__weddingColor" key={color} style={{ backgroundColor: color }}>{color}</span>)}
		</p>
		<p className="colorsPage__center">
			<img src={Colors} className="colorsPage__img" alt="Barvy svatby" />
		</p>
	</div>;
}
